import { useQuery } from "@tanstack/react-query";
import moment from "moment";
import { client_v2 } from "utils/api";
import { Modal } from "components";
import { Loader } from "components";

const ModalPackerUnControlledMissing = ({ type, date, handleClose }) => {
  const path =
    type === "uncontrolled_missing"
      ? "/stats/gdn_line_missings_uncontrolled_by_date"
      : "/stats/gdn_line_missings_pieceworkers_by_date";
  const {
    isLoading,
    isFetching,
    data = [],
  } = useQuery([path, date], () => client_v2.get(`${path}?date=${date}`), {
    select: ({ data }) => data,
    retry: false,
    refetchOnWindowFocus: false,
  });

  const is_loading = isLoading || isFetching;

  return (
    <Modal
      size="full no-padding"
      handleClose={handleClose}
      header={{
        title:
          type === "uncontrolled_missing"
            ? "Ilość braków zgłoszonych przez pakera bez kontroli"
            : "Ilość braków zgłoszonych przez pracowników akordowych",
      }}
    >
      {is_loading ? (
        <div className="p-t-10 p-b-10">
          <Loader />
        </div>
      ) : (
        data?.length > 0 && (
          <table class="table table-sm">
            <thead class="table__header">
              <tr>
                <th>SKU</th>
                <th>Piker</th>
                <th>Paker</th>
                <th>Data zgłoszenia braku</th>
              </tr>
            </thead>
            <tbody class="table__body">
              {data.map(
                ({
                  picker_name,
                  packer_name,
                  product_sku,
                  gdn_id,
                  gdn_identifier,
                  marked_as_missing_at,
                }) => (
                  <tr className="table-row">
                    <td>{product_sku}</td>
                    <td>{picker_name}</td>
                    <td>{packer_name}</td>
                    <td>
                      {marked_as_missing_at
                        ? moment(marked_as_missing_at).format(
                            "YYYY-MM-DD HH:mm"
                          )
                        : "-"}
                    </td>
                    <td>
                      <a className="link" href={`/gdns/${gdn_id}`}>
                        {gdn_identifier}
                      </a>
                    </td>
                  </tr>
                )
              )}
            </tbody>
          </table>
        )
      )}
    </Modal>
  );
};
export default ModalPackerUnControlledMissing;
